
import ConvertedToEmailNotice from '@/components/ConvertedToEmailNotice.vue'
import Notification from '@/components/NotificationSuccess.vue'
import { clearAuthToken } from '@/helpers/authToken'
import { logInWithToken } from '@/helpers/tokenLogin'
import api from '@/store/api'

export default {
  components: { Notification, ConvertedToEmailNotice },
  props: {
    legacy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      email: '',
      handle: '',
      password: '',
      error: '',
      convertedError: false,
      tries: 0,
      flash: false,
      passwordReset: false,
      successMessage: ''
    }
  },
  watch: {
    legacy() {
      this.error = ''
      this.convertedError = false
    }
  },
  mounted() {
    clearAuthToken()
    const resetLinkSent = this.$route.fullPath.includes('reset-link-sent')
    const passwordWasSet = this.$route.fullPath.includes('reset-success')
    this.passwordReset = resetLinkSent || passwordWasSet
    if (this.passwordReset) {
      this.successMessage = resetLinkSent
        ? "If an account exists for that email, we've sent a password reset link. Please check your inbox."
        : 'Your password has been set. Please login to access your dashboard.'
    }
  },
  methods: {
    loginAction: function () {
      const apiEndpoint = `tokens`
      const body = this.legacy
        ? {
            handle: this.handle,
            password: this.password
          }
        : {
            authentication_type: 'system_user',
            email: this.email.replace(/\s/g, '').toLowerCase(),
            password: this.password
          }

      api
        .call('POST', apiEndpoint, body, false)
        .then(response => {
          this.authenticate(response.data.token)
        })
        .catch(error => {
          if (error?.response?.data?.converted_to_email_signin) {
            this.convertedError = true
            this.error = ''
            return
          }
          this.error = this.legacy ? 'Incorrect handle or password' : 'Incorrect email or password'
          this.tries++
          if (this.tries > 1) {
            this.flash = true
            setTimeout(() => {
              this.flash = false
            }, 200)
          }
        })
    },
    signUpClicked() {
      window.location = 'https://www.bottle.com/book-a-demo'
    },
    authenticate: async function (token) {
      const loggedIn = await logInWithToken(token, { store: this.$store, router: this.$router })
      if (!loggedIn) this.error = 'Your account does not have access to any resources'
    }
  }
}
